<form [formGroup]="healthInsuranceForm" >
    <div class="step-container">
      <ng-template #labelTen>{{ getTranslation('healthInsurance.title') }}</ng-template>
      <div class="step-title">
        {{ isEditable ? getTranslation('healthInsurance.title') : getTranslation('healthInsurance.blockedForEdit') }}
        <span *ngIf="!isEditable" class="badge badge-warning ml-2" style="font-size: 0.75rem;">(Read Only)</span>
      </div>
  
      
      
      <div *ngIf="isJsonShow">
        
        {{healthInsuranceForm.value | json}}
      </div>


      <div class="row gx-2">
        <!-- Medical Insurance Question -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-5 mb-0" [ngClass]="{'text-danger': healthInsuranceForm.controls['HasMedicalInsurance'].invalid && submitted}">{{ getTranslation('healthInsurance.question.hasInsurance') }} <span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center">
              <label class="mr-5">
                <input type="radio" class="form-check-input" formControlName="HasMedicalInsurance" [value]="true" class="me-2"> 
                {{ getTranslation('common.yes') }}
              </label>
              <label>
                <input type="radio" class="form-check-input" formControlName="HasMedicalInsurance" [value]="false"> 
                {{ getTranslation('common.no') }}
              </label>

              <div *ngIf="submitted && healthInsuranceForm.controls['HasMedicalInsurance'].invalid" class="text-danger-val">
                {{ getTranslation('validation.requiredField') }}
              </div>

              
            </div>
          </div>
        </div>
  </div>





        <!-- Details if Yes -->
        <div *ngIf="healthInsuranceForm.get('HasMedicalInsurance')?.value === true" >
          
            <div class="form-row gs-2">
            <div class="form-group col-md-4">
              <label for="InsuranceCompany" class="form-label">{{ getTranslation('healthInsurance.companyName') }}: <span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="InsuranceCompany" formControlName="InsuranceCompany" maxlength="50" [placeholder]="getTranslation('healthInsurance.companyNamePlaceholder')">
              
              <div *ngIf="submitted && healthInsuranceForm.controls['InsuranceCompany'].invalid" class="text-danger">
                {{ getTranslation('validation.requiredField') }}
              </div>

            
            </div>
            <div class="form-group col-md-4">
              <label for="PolicyNumber" class="form-label">{{ getTranslation('healthInsurance.policyNumber') }}: <span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="PolicyNumber" formControlName="PolicyNumber" maxlength="50" (keypress)="genericValidations.onlyNumberWithoutPointValidator($event)" [placeholder]="getTranslation('healthInsurance.policyNumberPlaceholder')">
           
              <div *ngIf="submitted && healthInsuranceForm.controls['PolicyNumber'].invalid" class="text-danger">
                {{ getTranslation('validation.requiredField') }}
              </div>

            </div>
            <div class="form-group col-md-4">
              <label for="ValidUntil" class="form-label">{{ getTranslation('healthInsurance.validUntil') }}: <span class="text-danger">*</span></label>
              <app-custom-date-picker
                [formControl]="getValidUntilControl()"
                [placeholder]="getTranslation('healthInsurance.validUntilPlaceholder')"
                [minDate]="currentDate"
              ></app-custom-date-picker>
           
              <div *ngIf="submitted && healthInsuranceForm.controls['ValidUntil'].invalid" class="text-danger">
                {{ getTranslation('validation.requiredField') }}
              </div>

            </div>
          </div>
        </div>
  
        <div class="row gx-2">

        <!-- Financial Support Question -->
        <div class="form-group col-12 mb-3">
          <div class="row">
            <label class="form-label col-md-5 mb-0" [ngClass]="{'text-danger': healthInsuranceForm.controls['HasHandleMedicalEmergency'].invalid && submitted}">{{ getTranslation('healthInsurance.question.financialSupport') }} <span class="text-danger">*</span></label>
            <div class="col-md-4 d-flex align-items-center">
              <label class="mr-5">
                <input type="radio" class="form-check-input" formControlName="HasHandleMedicalEmergency" [value]="true" class="me-2"> 
                {{ getTranslation('common.yes') }}
              </label>
              <label>
                <input type="radio" class="form-check-input" formControlName="HasHandleMedicalEmergency" [value]="false"> 
                {{ getTranslation('common.no') }}
              </label>


              <div *ngIf="submitted && healthInsuranceForm.controls['HasHandleMedicalEmergency'].invalid" class="text-danger-val">
                {{ getTranslation('validation.requiredField') }}
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
  








    <div class="chkbox-cont">
      <div class="vendorformchk ml-0">
        <input type="checkbox" formControlName="IsHealthInsuranceConcentGiven"   name="IsHealthInsuranceConcentGiven" /> {{ getTranslation('healthInsurance.declaration') }}
      </div>
      <div *ngIf="shouldShowCheckboxValidation()" class="text-danger">
        {{ getTranslation('healthInsurance.declarationRequired') }}
      </div>
    </div>
    








  <!-- Buttons start -->
  <div class="btn-group vendortitle nb-progress-bar margincss mobile-responsive"  *ngIf="!isPreviewMode && isEditable">
    <button type="button" class="btn savedraftbtn" 
            *ngIf="healthInsuranceForm.get('SaveMode')?.value !== SaveMode.SAVE"
            (click)="onSubmit(SaveMode.DRAFT)">
      <i class="fas fa-save mr-2"></i>{{ getTranslation('button.saveAsDraft') }}
    </button>
    <button type="button" class="btn prevbtn" (click)="goToBack()">
      <i class="fas fa-arrow-left mr-2"></i>{{ getTranslation('button.previous') }}
    </button>
    <button type="button" class="btn nextbtn" (click)="onSubmit(SaveMode.SAVE)">
      <i class="fas fa-arrow-right mr-2"></i>{{ getTranslation('button.next') }}
    </button>
  </div>
   <!-- Buttons ends -->
  </form>
  